export default __webpack_public_path__ + "c821040.png";